import { IressSkeleton } from '@iress-oss/ids-components';
import { ReactNode } from 'react';

export const EntityDetailsLoader = (): ReactNode => (
    <div data-testid="entity-details-loader">
        <IressSkeleton mode="text" textVariant="display4" width="25%" data-testid="entity-details-loader__heading" />
        <IressSkeleton textVariant="display" width="25%" data-testid="entity-details-loader__text" />
    </div>
);
